import React, { useState } from 'react';
import { X, Share2, Copy } from 'lucide-react';
import './WhatsAppQR.css';

interface WhatsAppQRProps {
  isOpen: boolean;
  onClose: () => void;
}

const WhatsAppQR: React.FC<WhatsAppQRProps> = ({ isOpen, onClose }) => {
  const [copied, setCopied] = useState(false);
  const whatsappUrl = 'https://www.whatsapp.com/channel/0029Va3Fe3j8V0twuTyCRm2g';
  
  // Generate QR code using a free service
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(whatsappUrl)}`;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(whatsappUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const shareLink = () => {
    if (navigator.share) {
      navigator.share({
        title: 'Follow Mining & Energy on WhatsApp',
        text: 'Stay updated with Mining & Energy on WhatsApp!',
        url: whatsappUrl
      });
    } else {
      copyToClipboard();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="whatsapp-qr-overlay" onClick={onClose}>
      <div className="whatsapp-qr-container" onClick={(e) => e.stopPropagation()}>
        <div className="whatsapp-qr-header">
          <h3>Follow Mining & Energy on WhatsApp</h3>
          <button className="close-button" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        
        <div className="whatsapp-qr-content">
          <div className="qr-code-section">
            <img 
              src={qrCodeUrl} 
              alt="WhatsApp QR Code" 
              className="qr-code-image"
            />
            <p className="qr-instructions">
              Scan this QR code with your WhatsApp to join our channel
            </p>
          </div>
          
          <div className="link-section">
            <div className="link-display">
              <span className="link-text">{whatsappUrl}</span>
              <button 
                className="copy-button"
                onClick={copyToClipboard}
                title="Copy link"
              >
                <Copy size={16} />
              </button>
            </div>
            {copied && <span className="copied-message">Link copied!</span>}
            
            <div className="action-buttons">
              <button 
                className="share-button"
                onClick={shareLink}
              >
                <Share2 size={16} />
                Share Link
              </button>
              
              <a 
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-button"
              >
                Open WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppQR; 